TOURNEE 61 STRASBOURG

;; ;:, <template>
  <VContainer id="general-dashboard" fluid class="mx-0 pa-0">
    <VRow dense>
      <VCol cols="12" md="4">
        <NotificationList title="Produits" :notification-type="NotificationType.PRODUCT_ALERT" color="#facd55"
          height="320px" />
      </VCol>
      <VCol cols="12" md="4">
        <NotificationList title="Laveries" :notification-type="NotificationType.LAVERIE_ALERT" color="#e55b83"
          height="320px" />
      </VCol>
      <VCol cols="12" md="4">
        <NotificationList title="Pièces de Rechange" :notification-type="NotificationType.SPAREPART_ALERT"
          color="#62c1c0" height="320px" />
      </VCol>
    </VRow>
    <!--
    <VRow dense>
      <VCol cols="12" md="6">
        <VCard elevation="4" flat>
          <MonthlySales />
        </VCard>
      </VCol>

      <VCol cols="12" md="6">
        <VCard elevation="4" flat>
          <OrderForecast />
        </VCard>
      </VCol>
    </VRow>
    <VRow dense>
      <VCol cols="12" md="6">
        <VCard elevation="4" flat>
          <ProductAnalysis />
        </VCard>
      </VCol>
      <VCol cols="12" md="6">
        <VCard elevation="4" flat>
          <BrowserUsage />
        </VCard>
      </VCol>
    </VRow>
    -->
    <VRow dense>
      <VCol cols="12">
        <VCard elevation="4" flat>
          <InProgressTaskList />
        </VCard>
      </VCol>
    </VRow>
  </VContainer>
</template>

<script setup lang="ts">
import MonthlySales from "@/components/dashboard/MonthlySales.vue";
import OrderForecast from "@/components/dashboard/OrderForecast.vue";
import BrowserUsage from "@/components/dashboard/BrowserUsage.vue";
import NotificationList from "@/components/dashboard/NotificationList.vue";
import { NotificationType } from "@/types";
import ProductAnalysis from "@/components/dashboard/ProductAnalysis.vue";
import InProgressTaskList from "@/components/dashboard/InProgressTaskList.vue";
</script>

<style scoped>
#dashboard {
  width: 100%;
}
</style>
